import { render, staticRenderFns } from "./MySubtitle.vue?vue&type=template&id=311cf210&scoped=true&"
import script from "./MySubtitle.vue?vue&type=script&lang=js&"
export * from "./MySubtitle.vue?vue&type=script&lang=js&"
import style0 from "./MySubtitle.vue?vue&type=style&index=0&id=311cf210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311cf210",
  null
  
)

export default component.exports